<form *ngIf="formGroup" [formGroup]="formGroup">
    <form-email-verification *ngIf="emailVerification" formControlName="emailVerification"></form-email-verification>
    <div *ngIf="captcha">
        <form-captcha formControlName="captchaVerification"></form-captcha>
        <mat-error
            *ngIf="
            formGroup.get('captchaVerification')?.touched &&
            formGroup.get('captchaVerification')?.hasError('required')
            "
        >
            {{ "forms.errors.field-required" | translate }}
        </mat-error>
    </div>
    <div class="text-end">
        <button mat-raised-button (click)="onCancel()" class="me-2">
            {{ "actions.cancel" | translate }}
        </button>
        <button mat-raised-button color="primary" (click)="onFormSend()">
            {{ "components.form-send.send-button-label" | translate }}
        </button>
    </div>
</form>
  